import { usePushSubscription } from 'server';

/**
 * Event fires when IMS sends push notification that player's IP has changed.
 * Subscription type 'ip-change' must be configured to receive this notifications.
 * More specifically 'ip-change' event means push (code 31133) with actionIpChangedInfo in pushMessage.data.action.
 * @memberOf Playtech.API.events
 * @event ip-change
 * @type {callback}
 * @example Playtech.on('ip-change', () => { ... });
 */
export const EVENT_IP_CHANGE = 'ip-change';

export const useOnIpChange = (eventTarget) => {
    usePushSubscription(31133, () => pushMessage => {
        const { action } = pushMessage.data;
        const actionType = Object.keys(action);

        if (actionType.includes('actionIpChangedInfo')) {
            const event = new CustomEvent(EVENT_IP_CHANGE);

            eventTarget.dispatchEvent(event);
        }
    });
};
